import React, { useEffect, useState } from "react"
import ViewFinalConfig from "./ViewFinalConfig"
import Cookies from "js-cookie"

const OpenDockFinalConfig = props => {
  const [baseConfig, setBaseConfig] = useState(null)
  const [loading, setLoading] = useState(false)
  const api_url = process.env.REACT_APP_API_URL

  useEffect(() => {
    getConfig()
  }, [])

  const getConfig = async () => {
    try {
      setLoading(true)
      const token = Cookies.get("idToken")

      const config = {
        method: "GET",
        headers: {},
      }

      const response = await fetch(
        api_url + "locations/config/final/" + props.locationId,
        config
      )

      if (!response.ok) {
        throw new Error("Request failed")
      }

      const jsonData = await response.json()
      if (jsonData) {
        setBaseConfig(jsonData?.loc_base_config)
      }
      setLoading(false)
    } catch (error) {
      console.error("Error:", error)
      setLoading(false)
    }
  }

  return (
    <>
      <ViewFinalConfig
        data={baseConfig}
        locationId={props.locationId}
        refresh={getConfig}
        allowEdit={props.allowEdit}
      ></ViewFinalConfig>
    </>
  )
}

export default OpenDockFinalConfig
